module.exports = __webpack_public_path__ + "img/patrim01.f6988edc.png";